import { Alert, Button, Spin } from 'antd';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import PhotosViewer from '../../components/PhotosViewer/PhotosViewer';
import BookingApi from '../../functions/api/booking/BookingApi';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import UserApi from '../../functions/api/user/UserApi';
import MyUtil from '../../functions/MyUtil';
import './BookingInfo.scss';

function BookingInfo(props) {
  const [booking, setBooking] = useState();
  const [procs, setProcs] = useState();
  const [imgs, setImgs] = useState([]);
  const [isPhotoViewerOpen, setPhotoViewerOpen] = useState(false);

  const { bookingCode } = useParams();

  useEffect(() => {
    getBookingByHashAndCode().then(setBooking);
    getProcs().then(setProcs);
  }, []);

  useEffect(() => {
    if (!booking) {
      return;
    }

    convertToViewerFormat(booking?.bookingImages, booking?.user_acc_id).then(
      setImgs
    );
  }, [booking]);

  async function getBookingByHashAndCode() {
    const { hash } = MyUtil.getQueryParam('hash');
    const booking = await BookingApi.getBookingByCodeAndHash(bookingCode, hash);

    return booking;
  }

  async function getProcs() {
    const procs = await PartnerApi.getProcedures();
    return procs;
  }
  function handleClose() {
    setPhotoViewerOpen(false);

    return true;
  }
  function handleClick() {
    setPhotoViewerOpen(true);
  }

  async function convertToViewerFormat(arrImgs, userId) {
    let images = arrImgs;

    if (userId) {
      images = await UserApi.getImages(userId);
    }

    if (!images) {
      return [];
    }

    return images.map((image) => {
      const pr = procs.find((p) => p.proc_id === image.proc_id);
      const url = image.img_url || image.user_img_url;
      return {
        src: url,
        thumbnail: url,
        caption: pr?.proc_name,
      };
    });
  }
  const bookingPriceTotal =
    booking?.book_price_total_actual ?? booking?.book_prie_tota;
  const paidAmount = booking?.paid_amount || 0;
  const pricePayment = bookingPriceTotal - paidAmount;

  const data = [
    {
      title: 'Mã Booking',
      content: booking?.book_code ?? '',
    },
    {
      title: 'Khách hàng',
      content: booking?.cstm_name ?? '',
    },
    {
      title: 'Giờ nhận xe',
      content: moment(booking?.book_rental_date_actual).format('HH:mm'),
    },
    {
      title: 'Ngày nhận xe',
      content: moment(
        booking?.book_rental_date_actual ?? booking?.book_rent_date
      ).format('DD/MM/YYYY'),
    },
    {
      title: 'Giờ trả xe',
      content: moment(booking?.book_return_date_actual).format('HH:mm'),
    },
    {
      title: 'Ngày trả xe',
      content: moment(
        booking?.book_return_date_actual ?? booking?.book_retun_date
      ).format('DD/MM/YYYY'),
    },
    {
      title: 'Tên xe',
      content: booking?.vhc_part_name_actual ?? booking?.vhc_part_name,
    },
    {
      title: 'Số ngày thuê',
      content: `${booking?.book_day_num_actual ?? booking?.book_day_num} ngày`,
    },
    {
      title: 'Tổng giá',
      content: `${
        bookingPriceTotal ? MyUtil.currencyFormat(bookingPriceTotal) : 0
      } VND`,
    },
    {
      title: 'Phí bảo hiểm/giao nhận/rửa xe (nếu có)',
      content: `${
        booking?.extra_fee ? MyUtil.currencyFormat(booking?.extra_fee) : 0
      } VND`,
    },
    {
      title: 'Cọc Chungxe',
      content: `${MyUtil.currencyFormat(paidAmount)} VND`,
    },
    {
      title: 'Thanh toán khi nhận xe',
      content: `${pricePayment ? MyUtil.currencyFormat(pricePayment) : 0} VND`,
    },
    {
      title: 'Lịch trình đi',
      content: booking?.book_schl ?? '',
    },
  ];

  const generalProcedures = [
    'Giấy tờ thế chấp (bản gốc giữ lại): Hộ khẩu/KT3/Hộ chiếu',
    'Tài sản thế chấp (giữ lại): Xe + đăng ký xe/ Tiền > 20 triệu đồng',
    'GPLX, CMND (xác minh, không giữ lại)',
  ];

  const listItems = generalProcedures.map((procedure) => (
    <li style={{ paddingBottom: '10px' }}>{procedure}</li>
  ));
  const listInfo = data.map((li) => (
    <li style={{ paddingBottom: '10px' }}>{`${li.title}: ${li.content}`}</li>
  ));

  if (!booking) {
    return <Spin />;
  }

  return (
    <Container fluid className="partner-widget">
      <h1 color="primary">Thủ tục giấy tờ, và thông tin về khách hàng</h1>
      <div className="col-xs-12">
        <ul className="intro-ul">{listInfo}</ul>
        <b>Thủ tục chung:</b>
        <ul className="intro-ul">{listItems}</ul>
      </div>
      {!isEmpty(imgs) ? (
        <>
          {isPhotoViewerOpen && (
            <PhotosViewer
              isOpen
              onClose={handleClose}
              imgs={imgs}
              showThumbnails
            />
          )}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button type="primary" onClick={handleClick}>
              Xem chi tiết hồ sơ
            </Button>
          </div>
        </>
      ) : (
        <Alert message="Khách thuê chưa upload hồ sơ" type="warning" />
      )}
    </Container>
  );
}
export default BookingInfo;
